import { useMutation, useQueryClient } from "@tanstack/react-query";

import { USER_INFO_QUERY_KEY } from "Auth/Api/Queries/useUserInfoQuery";
import { JWT_KEY } from "Auth/Models/AuthConstants";
import {
  type FetchResponseOfError,
  putAuthPassword,
  type SetPasswordCommand,
} from "Infrastructure/Api/Api";
import { ApiCallError, isSuccessResponse } from "Infrastructure/Api/ApiUtils";

export function useSetPasswordMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: SetPasswordCommand) => putAuthPassword(request),
    onSuccess: (data) => {
      if (!isSuccessResponse(data)) {
        throw new ApiCallError(data as unknown as FetchResponseOfError);
      }

      localStorage.setItem(
        JWT_KEY,
        `Bearer ${data.data.signInResult.userInfo.token}`,
      );
      queryClient.invalidateQueries({ queryKey: [USER_INFO_QUERY_KEY] });
    },
  });
}
